import { Link } from "react-router-dom";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";

function Offseason(props) {
  return (
    <Row className="justify-content-center text-center py-5">
      <Col md={8} lg={6}>
        <div style={{ fontSize: "5rem", lineHeight: 1 }}>🏴‍☠️</div>
        <h1 className="mt-3">That's a wrap on DEF CON 34</h1>
        <p className="lead text-muted">
          Live tracking is off until next year.
        </p>
        <p className="text-muted">
          Every August this map follows me around Las Vegas, one GPS point at a
          time. DEF CON 34 ran August 6&ndash;9, 2026 at the Las Vegas
          Convention Center, and the whole trip is still on the map.
        </p>
        <Button as={Link} to="/dc34" variant="primary" size="lg" className="mt-2">
          See where I was at DEF CON 34
        </Button>
        <p className="text-muted mt-5 mb-0">
          <small>Check back next August for DEF CON 35.</small>
        </p>
      </Col>
    </Row>
  );
}

export default Offseason;
